import { MAX_MOBILE_SCREEN_WIDTH } from "../constants/constants";

const getTooltipLocation = () => {
    return window.innerWidth < MAX_MOBILE_SCREEN_WIDTH ? 'top' : 'right';
}

export default getTooltipLocation;